import Model from './Model';

export default class EmbedPageSettings extends Model {
  resource() {
    return 'hosted-page-settings';
  }
}
